export default __webpack_public_path__ + "static/media/4156.5457f800.png";